import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import emarService from "../services/emar-medpass-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { selectUsers } from "../state/reducers/userSlice";
import Loader from "react-loader-spinner";

const tablePropsInit = {
  columns: [
    { key: "title", title: "Name" },
    { key: "display_time", title: "Start time" }
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const EmarRanges = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const { user } = useSelector(selectUsers);
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await emarService.getRanges(user?.facility);
      setLoading(false);
      dispatch(updateData(resp));
    }
  };

  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>


      <div className="bg-white w-full   mx-auto mt-3 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-3 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl"></span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mb--3 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className={`absolute w-4 h-4  right-7 bottom-4`}
              ></img>
            </span>


          </div>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(EmarRanges)
);